import React, { useState } from 'react';
import { Modal, Input, Select } from 'antd';
import { AccountLevel } from '../../../Modules/Account/Model/Account';
import { creatableLevels, levelKor } from '../../../Utils/permission';
import { CreateAccountDTO } from '../../../Modules/Account/Domain/Repositories/AccountRepository';

interface Props {
  currentUserGrade: AccountLevel;
  open: boolean;
  onClose: () => void;
  onSubmit: (dto: CreateAccountDTO) => void;
}

const { Option } = Select;

const AccountAddModal = ({ currentUserGrade, open, onClose, onSubmit }: Props) => {
  const [form, setForm] = useState({
    username: '',
    password: '',
    name: '',
    grade: creatableLevels(currentUserGrade)[0] ?? 'SELLER',
    memo: '',
  });

  const levels = creatableLevels(currentUserGrade);

  return (
    <Modal title="계정 생성" open={open} onCancel={onClose}
      onOk={() => onSubmit(form)} okText="생성" cancelText="취소">
            <Input placeholder="아이디" maxLength={14} value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} />

      <Input.Password placeholder="비밀번호" style={{ marginTop: 8 }}
        value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
      <Input placeholder="이름" style={{ marginTop: 8 }}
        value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
      <Select value={form.grade} style={{ width: '100%', marginTop: 8 }}
        onChange={(v) => setForm({ ...form, grade: v as AccountLevel })}>
        {levels.map(l => <Option key={l} value={l}>{levelKor[l]}</Option>)}
      </Select>
      <Input.TextArea rows={4} placeholder="메모" style={{ marginTop: 8 }}
        value={form.memo} onChange={e => setForm({ ...form, memo: e.target.value })} />
    </Modal>
  );
};

export default AccountAddModal;
